module.exports = __webpack_public_path__ + "static/WSC_Group_2018_Self-Managed_Superfund_Check_List-e1b41fcaa645be7e9d404f0964b6b22d.pdf";